/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */
import { sortObjectKeysUsingValue } from './functions';

export const languageList: Record< string, string > = sortObjectKeysUsingValue(
	{
		af: _x( 'Afrikaans', 'text', 'nelio-ab-testing' ),
		sq: _x( 'Albanian', 'text', 'nelio-ab-testing' ),
		ar: _x( 'Arabic (Standard)', 'text', 'nelio-ab-testing' ),
		'ar-dz': _x( 'Arabic (Algeria)', 'text', 'nelio-ab-testing' ),
		'ar-bh': _x( 'Arabic (Bahrain)', 'text', 'nelio-ab-testing' ),
		'ar-eg': _x( 'Arabic (Egypt)', 'text', 'nelio-ab-testing' ),
		'ar-iq': _x( 'Arabic (Iraq)', 'text', 'nelio-ab-testing' ),
		'ar-jo': _x( 'Arabic (Jordan)', 'text', 'nelio-ab-testing' ),
		'ar-kw': _x( 'Arabic (Kuwait)', 'text', 'nelio-ab-testing' ),
		'ar-lb': _x( 'Arabic (Lebanon)', 'text', 'nelio-ab-testing' ),
		'ar-ly': _x( 'Arabic (Libya)', 'text', 'nelio-ab-testing' ),
		'ar-ma': _x( 'Arabic (Morocco)', 'text', 'nelio-ab-testing' ),
		'ar-om': _x( 'Arabic (Oman)', 'text', 'nelio-ab-testing' ),
		'ar-qa': _x( 'Arabic (Qatar)', 'text', 'nelio-ab-testing' ),
		'ar-sa': _x( 'Arabic (Saudi Arabia)', 'text', 'nelio-ab-testing' ),
		'ar-sy': _x( 'Arabic (Syria)', 'text', 'nelio-ab-testing' ),
		'ar-tn': _x( 'Arabic (Tunisia)', 'text', 'nelio-ab-testing' ),
		'ar-ae': _x( 'Arabic (U.A.E.)', 'text', 'nelio-ab-testing' ),
		'ar-ye': _x( 'Arabic (Yemen)', 'text', 'nelio-ab-testing' ),
		an: _x( 'Aragonese', 'text', 'nelio-ab-testing' ),
		hy: _x( 'Armenian', 'text', 'nelio-ab-testing' ),
		as: _x( 'Assamese', 'text', 'nelio-ab-testing' ),
		ast: _x( 'Asturian', 'text', 'nelio-ab-testing' ),
		az: _x( 'Azerbaijani', 'text', 'nelio-ab-testing' ),
		eu: _x( 'Basque', 'text', 'nelio-ab-testing' ),
		bg: _x( 'Bulgarian', 'text', 'nelio-ab-testing' ),
		be: _x( 'Belarusian', 'text', 'nelio-ab-testing' ),
		bn: _x( 'Bengali', 'text', 'nelio-ab-testing' ),
		bs: _x( 'Bosnian', 'text', 'nelio-ab-testing' ),
		br: _x( 'Breton', 'text', 'nelio-ab-testing' ),
		my: _x( 'Burmese', 'text', 'nelio-ab-testing' ),
		ca: _x( 'Catalan', 'text', 'nelio-ab-testing' ),
		ch: _x( 'Chamorro', 'text', 'nelio-ab-testing' ),
		ce: _x( 'Chechen', 'text', 'nelio-ab-testing' ),
		zh: _x( 'Chinese', 'text', 'nelio-ab-testing' ),
		'zh-hk': _x( 'Chinese (Hong Kong)', 'text', 'nelio-ab-testing' ),
		'zh-cn': _x( 'Chinese (PRC)', 'text', 'nelio-ab-testing' ),
		'zh-sg': _x( 'Chinese (Singapore)', 'text', 'nelio-ab-testing' ),
		'zh-tw': _x( 'Chinese (Taiwan)', 'text', 'nelio-ab-testing' ),
		cv: _x( 'Chuvash', 'text', 'nelio-ab-testing' ),
		co: _x( 'Corsican', 'text', 'nelio-ab-testing' ),
		cr: _x( 'Cree', 'text', 'nelio-ab-testing' ),
		hr: _x( 'Croatian', 'text', 'nelio-ab-testing' ),
		cs: _x( 'Czech', 'text', 'nelio-ab-testing' ),
		da: _x( 'Danish', 'text', 'nelio-ab-testing' ),
		nl: _x( 'Dutch (Standard)', 'text', 'nelio-ab-testing' ),
		'nl-be': _x( 'Dutch (Belgian)', 'text', 'nelio-ab-testing' ),
		en: _x( 'English', 'text', 'nelio-ab-testing' ),
		'en-au': _x( 'English (Australia)', 'text', 'nelio-ab-testing' ),
		'en-bz': _x( 'English (Belize)', 'text', 'nelio-ab-testing' ),
		'en-ca': _x( 'English (Canada)', 'text', 'nelio-ab-testing' ),
		'en-ie': _x( 'English (Ireland)', 'text', 'nelio-ab-testing' ),
		'en-jm': _x( 'English (Jamaica)', 'text', 'nelio-ab-testing' ),
		'en-nz': _x( 'English (New Zealand)', 'text', 'nelio-ab-testing' ),
		'en-ph': _x( 'English (Philippines)', 'text', 'nelio-ab-testing' ),
		'en-za': _x( 'English (South Africa)', 'text', 'nelio-ab-testing' ),
		'en-tt': _x(
			'English (Trinidad & Tobago)',
			'text',
			'nelio-ab-testing'
		),
		'en-gb': _x( 'English (United Kingdom)', 'text', 'nelio-ab-testing' ),
		'en-us': _x( 'English (United States)', 'text', 'nelio-ab-testing' ),
		'en-zw': _x( 'English (Zimbabwe)', 'text', 'nelio-ab-testing' ),
		eo: _x( 'Esperanto', 'text', 'nelio-ab-testing' ),
		et: _x( 'Estonian', 'text', 'nelio-ab-testing' ),
		fo: _x( 'Faeroese', 'text', 'nelio-ab-testing' ),
		fj: _x( 'Fijian', 'text', 'nelio-ab-testing' ),
		fi: _x( 'Finnish', 'text', 'nelio-ab-testing' ),
		fr: _x( 'French (Standard)', 'text', 'nelio-ab-testing' ),
		'fr-be': _x( 'French (Belgium)', 'text', 'nelio-ab-testing' ),
		'fr-ca': _x( 'French (Canada)', 'text', 'nelio-ab-testing' ),
		'fr-fr': _x( 'French (France)', 'text', 'nelio-ab-testing' ),
		'fr-lu': _x( 'French (Luxembourg)', 'text', 'nelio-ab-testing' ),
		'fr-mc': _x( 'French (Monaco)', 'text', 'nelio-ab-testing' ),
		'fr-ch': _x( 'French (Switzerland)', 'text', 'nelio-ab-testing' ),
		fy: _x( 'Frisian', 'text', 'nelio-ab-testing' ),
		fur: _x( 'Friulian', 'text', 'nelio-ab-testing' ),
		'gd-ie': _x( 'Gaelic (Irish)', 'text', 'nelio-ab-testing' ),
		gl: _x( 'Galacian', 'text', 'nelio-ab-testing' ),
		ka: _x( 'Georgian', 'text', 'nelio-ab-testing' ),
		de: _x( 'German (Standard)', 'text', 'nelio-ab-testing' ),
		'de-at': _x( 'German (Austria)', 'text', 'nelio-ab-testing' ),
		'de-de': _x( 'German (Germany)', 'text', 'nelio-ab-testing' ),
		'de-li': _x( 'German (Liechtenstein)', 'text', 'nelio-ab-testing' ),
		'de-lu': _x( 'German (Luxembourg)', 'text', 'nelio-ab-testing' ),
		'de-ch': _x( 'German (Switzerland)', 'text', 'nelio-ab-testing' ),
		el: _x( 'Greek', 'text', 'nelio-ab-testing' ),
		gu: _x( 'Gujurati', 'text', 'nelio-ab-testing' ),
		ht: _x( 'Haitian', 'text', 'nelio-ab-testing' ),
		he: _x( 'Hebrew', 'text', 'nelio-ab-testing' ),
		hi: _x( 'Hindi', 'text', 'nelio-ab-testing' ),
		hu: _x( 'Hungarian', 'text', 'nelio-ab-testing' ),
		is: _x( 'Icelandic', 'text', 'nelio-ab-testing' ),
		id: _x( 'Indonesian', 'text', 'nelio-ab-testing' ),
		iu: _x( 'Inuktitut', 'text', 'nelio-ab-testing' ),
		ga: _x( 'Irish', 'text', 'nelio-ab-testing' ),
		it: _x( 'Italian (Standard)', 'text', 'nelio-ab-testing' ),
		'it-ch': _x( 'Italian (Switzerland)', 'text', 'nelio-ab-testing' ),
		ja: _x( 'Japanese', 'text', 'nelio-ab-testing' ),
		kn: _x( 'Kannada', 'text', 'nelio-ab-testing' ),
		ks: _x( 'Kashmiri', 'text', 'nelio-ab-testing' ),
		kk: _x( 'Kazakh', 'text', 'nelio-ab-testing' ),
		km: _x( 'Khmer', 'text', 'nelio-ab-testing' ),
		ky: _x( 'Kirghiz', 'text', 'nelio-ab-testing' ),
		tlh: _x( 'Klingon', 'text', 'nelio-ab-testing' ),
		ko: _x( 'Korean', 'text', 'nelio-ab-testing' ),
		'ko-kp': _x( 'Korean (North Korea)', 'text', 'nelio-ab-testing' ),
		'ko-kr': _x( 'Korean (South Korea)', 'text', 'nelio-ab-testing' ),
		la: _x( 'Latin', 'text', 'nelio-ab-testing' ),
		lv: _x( 'Latvian', 'text', 'nelio-ab-testing' ),
		lt: _x( 'Lithuanian', 'text', 'nelio-ab-testing' ),
		lb: _x( 'Luxembourgish', 'text', 'nelio-ab-testing' ),
		mk: _x( 'FYRO Macedonian', 'text', 'nelio-ab-testing' ),
		ms: _x( 'Malay', 'text', 'nelio-ab-testing' ),
		ml: _x( 'Malayalam', 'text', 'nelio-ab-testing' ),
		mt: _x( 'Maltese', 'text', 'nelio-ab-testing' ),
		mi: _x( 'Maori', 'text', 'nelio-ab-testing' ),
		mr: _x( 'Marathi', 'text', 'nelio-ab-testing' ),
		mo: _x( 'Moldavian', 'text', 'nelio-ab-testing' ),
		nv: _x( 'Navajo', 'text', 'nelio-ab-testing' ),
		ng: _x( 'Ndonga', 'text', 'nelio-ab-testing' ),
		ne: _x( 'Nepali', 'text', 'nelio-ab-testing' ),
		no: _x( 'Norwegian', 'text', 'nelio-ab-testing' ),
		nb: _x( 'Norwegian (Bokmal)', 'text', 'nelio-ab-testing' ),
		nn: _x( 'Norwegian (Nynorsk)', 'text', 'nelio-ab-testing' ),
		oc: _x( 'Occitan', 'text', 'nelio-ab-testing' ),
		or: _x( 'Oriya', 'text', 'nelio-ab-testing' ),
		om: _x( 'Oromo', 'text', 'nelio-ab-testing' ),
		fa: _x( 'Persian/Farsi', 'text', 'nelio-ab-testing' ),
		'fa-ir': _x( 'Persian/Iran', 'text', 'nelio-ab-testing' ),
		pl: _x( 'Polish', 'text', 'nelio-ab-testing' ),
		pt: _x( 'Portuguese', 'text', 'nelio-ab-testing' ),
		'pt-br': _x( 'Portuguese (Brazil)', 'text', 'nelio-ab-testing' ),
		pa: _x( 'Punjabi', 'text', 'nelio-ab-testing' ),
		'pa-in': _x( 'Punjabi (India)', 'text', 'nelio-ab-testing' ),
		'pa-pk': _x( 'Punjabi (Pakistan)', 'text', 'nelio-ab-testing' ),
		qu: _x( 'Quechua', 'text', 'nelio-ab-testing' ),
		rm: _x( 'Rhaeto-Romanic', 'text', 'nelio-ab-testing' ),
		ro: _x( 'Romanian', 'text', 'nelio-ab-testing' ),
		'ro-mo': _x( 'Romanian (Moldavia)', 'text', 'nelio-ab-testing' ),
		ru: _x( 'Russian', 'text', 'nelio-ab-testing' ),
		'ru-mo': _x( 'Russian (Moldavia)', 'text', 'nelio-ab-testing' ),
		sz: _x( 'Sami (Lappish)', 'text', 'nelio-ab-testing' ),
		sg: _x( 'Sango', 'text', 'nelio-ab-testing' ),
		sa: _x( 'Sanskrit', 'text', 'nelio-ab-testing' ),
		sc: _x( 'Sardinian', 'text', 'nelio-ab-testing' ),
		gd: _x( 'Scots Gaelic', 'text', 'nelio-ab-testing' ),
		sd: _x( 'Sindhi', 'text', 'nelio-ab-testing' ),
		si: _x( 'Singhalese', 'text', 'nelio-ab-testing' ),
		sr: _x( 'Serbian', 'text', 'nelio-ab-testing' ),
		sk: _x( 'Slovak', 'text', 'nelio-ab-testing' ),
		sl: _x( 'Slovenian', 'text', 'nelio-ab-testing' ),
		so: _x( 'Somani', 'text', 'nelio-ab-testing' ),
		sb: _x( 'Sorbian', 'text', 'nelio-ab-testing' ),
		es: _x( 'Spanish', 'text', 'nelio-ab-testing' ),
		'es-ar': _x( 'Spanish (Argentina)', 'text', 'nelio-ab-testing' ),
		'es-bo': _x( 'Spanish (Bolivia)', 'text', 'nelio-ab-testing' ),
		'es-cl': _x( 'Spanish (Chile)', 'text', 'nelio-ab-testing' ),
		'es-co': _x( 'Spanish (Colombia)', 'text', 'nelio-ab-testing' ),
		'es-cr': _x( 'Spanish (Costa Rica)', 'text', 'nelio-ab-testing' ),
		'es-do': _x(
			'Spanish (Dominican Republic)',
			'text',
			'nelio-ab-testing'
		),
		'es-ec': _x( 'Spanish (Ecuador)', 'text', 'nelio-ab-testing' ),
		'es-sv': _x( 'Spanish (El Salvador)', 'text', 'nelio-ab-testing' ),
		'es-gt': _x( 'Spanish (Guatemala)', 'text', 'nelio-ab-testing' ),
		'es-hn': _x( 'Spanish (Honduras)', 'text', 'nelio-ab-testing' ),
		'es-mx': _x( 'Spanish (Mexico)', 'text', 'nelio-ab-testing' ),
		'es-ni': _x( 'Spanish (Nicaragua)', 'text', 'nelio-ab-testing' ),
		'es-pa': _x( 'Spanish (Panama)', 'text', 'nelio-ab-testing' ),
		'es-py': _x( 'Spanish (Paraguay)', 'text', 'nelio-ab-testing' ),
		'es-pe': _x( 'Spanish (Peru)', 'text', 'nelio-ab-testing' ),
		'es-pr': _x( 'Spanish (Puerto Rico)', 'text', 'nelio-ab-testing' ),
		'es-es': _x( 'Spanish (Spain)', 'text', 'nelio-ab-testing' ),
		'es-uy': _x( 'Spanish (Uruguay)', 'text', 'nelio-ab-testing' ),
		'es-ve': _x( 'Spanish (Venezuela)', 'text', 'nelio-ab-testing' ),
		sx: _x( 'Sutu', 'text', 'nelio-ab-testing' ),
		sw: _x( 'Swahili', 'text', 'nelio-ab-testing' ),
		sv: _x( 'Swedish', 'text', 'nelio-ab-testing' ),
		'sv-fi': _x( 'Swedish (Finland)', 'text', 'nelio-ab-testing' ),
		'sv-sv': _x( 'Swedish (Sweden)', 'text', 'nelio-ab-testing' ),
		ta: _x( 'Tamil', 'text', 'nelio-ab-testing' ),
		tt: _x( 'Tatar', 'text', 'nelio-ab-testing' ),
		te: _x( 'Teluga', 'text', 'nelio-ab-testing' ),
		th: _x( 'Thai', 'text', 'nelio-ab-testing' ),
		tig: _x( 'Tigre', 'text', 'nelio-ab-testing' ),
		ts: _x( 'Tsonga', 'text', 'nelio-ab-testing' ),
		tn: _x( 'Tswana', 'text', 'nelio-ab-testing' ),
		tr: _x( 'Turkish', 'text', 'nelio-ab-testing' ),
		tk: _x( 'Turkmen', 'text', 'nelio-ab-testing' ),
		uk: _x( 'Ukrainian', 'text', 'nelio-ab-testing' ),
		hsb: _x( 'Upper Sorbian', 'text', 'nelio-ab-testing' ),
		ur: _x( 'Urdu', 'text', 'nelio-ab-testing' ),
		ve: _x( 'Venda', 'text', 'nelio-ab-testing' ),
		vi: _x( 'Vietnamese', 'text', 'nelio-ab-testing' ),
		vo: _x( 'Volapuk', 'text', 'nelio-ab-testing' ),
		wa: _x( 'Walloon', 'text', 'nelio-ab-testing' ),
		cy: _x( 'Welsh', 'text', 'nelio-ab-testing' ),
		xh: _x( 'Xhosa', 'text', 'nelio-ab-testing' ),
		ji: _x( 'Yiddish', 'text', 'nelio-ab-testing' ),
		zu: _x( 'Zulu', 'text', 'nelio-ab-testing' ),
	}
);

export function getLanguageName(
	langCode: string,
	defaultName?: string
): string {
	const fallback = defaultName ?? _x( 'Unknown', 'text', 'nelio-ab-testing' );
	return languageList[ langCode ] ?? fallback;
}
